import styled from 'styled-components';

export const StyledHeader = styled('h1')({
  color: '#000',
  fontWeight: 600,
  lineHeight: '130%',
  fontSize: '20px',
  margin: 0,
  marginBottom: 8
});

export const StyledSubHeader = styled('h2')({
  color: '#000',
  fontWeight: 400,
  lineHeight: '166%',
  fontSize: '18px',
  margin: '30px 0 20px'
});
